import { render, staticRenderFns } from "./timeframes.vue?vue&type=template&id=1b34e541&scoped=true"
import script from "./timeframes.vue?vue&type=script&lang=js"
export * from "./timeframes.vue?vue&type=script&lang=js"
import style0 from "./timeframes.vue?vue&type=style&index=0&id=1b34e541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34e541",
  null
  
)

export default component.exports